//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../Die/Die.DieAttributesBuilder.js";
import "../Die/Die.DieDirectionBuilder.js";
import "../no/Expression.js";
import "../no/SelectBodyList.js";
import "../Die/Die.DiePlaneBuilder.js";
import "../no/Section.js";
import "../no/SelectBody.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AngleTolerance",1,0],[1,"Attributes",0,"Die.DieAttributesBuilder",0],[1,"ClearanceDirection",0,"Die.DieDirectionBuilder",0],[0,"ClearanceGeometryType",1,0],[1,"Distance",0,"Expression",0],[0,"DistanceTolerance",1,0],[1,"Geometry",0,"SelectBodyList",0],[1,"Offset",0,"Expression",0],[1,"Orientation",0,"Die.DiePlaneBuilder",0],[1,"Section",0,"Section",0],[1,"Target",0,"SelectBody",0],[0,"Type",1,0]],[],[]];
SPLM.Die.ClearanceBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.ClearanceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.ClearanceBuilder.Types = Object.freeze({
    "Gage" : "Gage", "Gripper" : "Gripper", "Lifter" : "Lifter"});

SPLM.Die.ClearanceBuilder.ClearanceGeometryTypes = Object.freeze({
    "Solid" : "Solid", "Section" : "Section"});

export default SPLM;